import CurrencyFormatter from "./currencyFormatter";

export type DisplayCurrency = "USD" | "ZAR";

const formatter = new CurrencyFormatter({
  decimalPlaces: 2,
  locale: "en-ZA",
});

export function normalizeDisplayCurrency(currency?: unknown): DisplayCurrency {
  return String(currency ?? "")
    .trim()
    .toUpperCase() === "USD"
    ? "USD"
    : "ZAR";
}

export function getDisplayCurrencyFromPreferences(
  preferences: unknown
): DisplayCurrency {
  if (
    typeof preferences === "object" &&
    preferences !== null &&
    "localCurrency" in preferences
  ) {
    return normalizeDisplayCurrency(
      (preferences as { localCurrency?: unknown }).localCurrency
    );
  }

  return "ZAR";
}

export function getDisplayPrice(
  priceUsd: number | null | undefined,
  priceZar: number | null | undefined,
  currency: DisplayCurrency
): number | null {
  if (currency === "USD") {
    return priceUsd ?? null;
  }

  return priceZar ?? null;
}

export function getUsdToZarRate(
  priceUsd: number | null | undefined,
  priceZar: number | null | undefined
): number {
  if (priceUsd && priceZar && priceUsd !== 0) {
    return priceZar / priceUsd;
  }

  return 0;
}

export function convertUsdToDisplayCurrency(
  amountUsd: number | null | undefined,
  currency: DisplayCurrency,
  usdToZarRate: number
): number | null {
  if (amountUsd === null || amountUsd === undefined) {
    return null;
  }

  if (currency === "ZAR") {
    return usdToZarRate > 0 ? amountUsd * usdToZarRate : null;
  }

  return amountUsd;
}

export function parseDisplayAmount(value: unknown): number {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value === "string") {
    const parsed = Number(value.replace(/,/g, "").replace(/[^\d.-]/g, ""));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
}

export function formatDisplayFiat(
  amount: number | null | undefined,
  currency: DisplayCurrency
): string {
  return formatter.formatFiat(amount ?? 0, currency);
}

export function getCurrencyPrefix(currency: DisplayCurrency): string {
  return currency === "ZAR" ? "R" : "$";
}
